
















































import { LeftMenu, point } from "@/api/user";
import Vue, { PropType } from "vue";
export default Vue.extend({
  components: {  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  props: {
    list: {
      type: Array as PropType<LeftMenu[]>,
    },
    // 选中的点
    selectIndex: {
      type: Number,
      default: -1,
    },
    types: {
      type: Number,
      default: 0,
    },
    isShipList:{
      type:Boolean,
      default:true
    }
  },
  methods: {
    selectPoint(index: number) {
      this.$emit("setSelect", index);
    },
    dialog(index = -1) {
      this.$emit("setSelect", index);
      this.$emit("showFoot", index);
    },
    del(index: number) {
      this.$emit("delList", index);
    },
  },
  
  watch: {
    selectIndex: function () {
      if (this.selectIndex > -1) {
        console.log(this.$refs.el_scrollbar);
        (this.$refs.el_scrollbar as HTMLFormElement).wrap.scrollTop =
          this.selectIndex * 32;
      }
    },
  },
});
